import { Box, Button, Grid, IconButton, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

const Objetivos = ({ datos, setDatos, errores }) => {
    const [form, setForm] = useState({
        factores: '',
        organizaciones: '',
        resultados: '',
        perspectivas: '',


    });
    const handleAdd = (e, type) => {
        setDatos({ target: { name: type, value: [...datos[type], form[type]] } });
        setForm({ ...form, [type]: '' });
    }
    const handleChange = (event) => {
        setDatos(event);
    }

    const removeEl = (index, type) => {
        setDatos({ target: { name: type, value: [...datos[type].filter((v, i) => i !== index)] } })
    };
    return (
        <Grid container spacing={1} sx={{ mb: { xs: 10, lg: 0 } }}>
            <Grid item lg={12} xs={12}>
                <Stack spacing={2}>
                    <TextField value={datos.proposito} onChange={handleChange} fullWidth name="proposito" multiline minRows={3} label="Propósitos por los que surgió la empresa" />
                    <Stack direction="row" spacing={2}>
                        <Box sx={{ width: '100%' }}>
                            <Stack direction="row" spacing={2}>
                                <TextField fullWidth value={form.factores} onChange={(e) => setForm({ ...form, factores: e.target.value })} name="factores" label="Factores que han favorecido el desarrollo de la empresa" />
                                <Button variant="contained" onClick={(e) => handleAdd(e, 'factores')}>Agregar</Button>
                            </Stack>
                            <ul>
                                {Array.isArray(datos.factores) && datos.factores.map((factor, index) => (
                                    <li style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography>{factor}</Typography>
                                        <IconButton onClick={() => removeEl(index, 'factores')}>X</IconButton>
                                    </li>
                                ))}
                            </ul>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <Stack direction="row" spacing={2}>
                                <TextField fullWidth value={form.organizaciones} onChange={(e) => setForm({ ...form, organizaciones: e.target.value })} name="organizaciones" label="Organizaciones que han contribuido al fortalecimiento de la empresa" />
                                <Button variant="contained" onClick={(e) => handleAdd(e, 'organizaciones')}>Agregar</Button>
                            </Stack>
                            <ul>
                                {Array.isArray(datos.organizaciones) && datos.organizaciones.map((organizacion, index) => (
                                    <li style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography>{organizacion}</Typography>
                                        <IconButton onClick={() => removeEl(index, 'organizaciones')}>X</IconButton>
                                    </li>
                                ))}
                            </ul>
                        </Box>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <Box sx={{ width: '100%' }}>
                            <Stack direction="row" spacing={2}>
                                <TextField value={form.resultados} onChange={(e) => setForm({ ...form, resultados: e.target.value })} fullWidth name="resultados" label="Resultados de empresa - socioeconómicos y ambientales" />
                                <Button variant="contained" onClick={(e) => handleAdd(e, 'resultados')}>Agregar</Button>
                            </Stack>
                            <ul>
                                {Array.isArray(datos.resultados) && datos.resultados.map((resultado, index) => (
                                    <li style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography>{resultado}</Typography>
                                        <IconButton onClick={() => removeEl(index, 'resultados')}>X</IconButton>
                                    </li>
                                ))}
                            </ul>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <Stack direction="row" spacing={2}>
                                <TextField value={form.perspectivas} onChange={(e) => setForm({ ...form, perspectivas: e.target.value })} fullWidth name="perspectivas" label="Perspectivas de desarrollo y beneficios que puede generar la empresa" />
                                <Button variant="contained" onClick={(e) => handleAdd(e, 'perspectivas')}>Agregar</Button>
                            </Stack>
                            <ul>
                                {Array.isArray(datos.perspectivas) && datos.perspectivas.map((perspectiva, index) => (
                                    <li style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography>{perspectiva}</Typography>
                                        <IconButton onClick={() => removeEl(index, 'perspectivas')}>X</IconButton>
                                    </li>
                                ))}
                            </ul>
                        </Box>
                    </Stack>
                </Stack>
            </Grid>
        </Grid>
    )
}

export default Objetivos